import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EmptyPageComponent } from '@modules/empty-page/empty-page.component';
import { UntilDestroy } from '@ngneat/until-destroy';
import { LoaderComponent } from 'mbs-ui-kit';
import { AddDataOrRunGSWHintComponent } from 'mbs-ui-shared@components/add-data-or-run-gsw-hint/add-data-or-run-gsw-hint.component';
import { ComputersFacade } from 'mbs-ui-shared@facades/computers.facade';

@UntilDestroy()
@Component({
  selector: 'mbs-computers-legacy',
  templateUrl: './computers-legacy.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AddDataOrRunGSWHintComponent, CommonModule, EmptyPageComponent, LoaderComponent]
})
export class ComputersLegacyComponent {
  public facade = inject(ComputersFacade);

  constructor() {
    this.facade.checkOneComputerExist();
  }
}
